import Dialog from '@material-ui/core/Dialog';
import { DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import React from 'react';

const Modal = ({title, content, actions, isOpen, fullScreen = false}) => {

    const open = isOpen[0];
    const setOpen = isOpen[1];
    return (<Dialog
        maxWidth="md"
        fullScreen={fullScreen}
        open={open}
        onClose={ () => setOpen(false) }
        scroll="paper"
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
    >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent  dividers={true}>
            {content}
        </DialogContent>
        <DialogActions>
            {actions.map( action => 
                 <Button key={action.text} onClick={action.onClick}>{action.text}</Button>
            )}
        </DialogActions>
    </Dialog>)
}

export default Modal;
